import { render } from "./EventDatePicker.vue?vue&type=template&id=222d1586"
import script from "./EventDatePicker.vue?vue&type=script&lang=js"
export * from "./EventDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy,QDate,QBtn});qInstall(script, 'directives', {ClosePopup});
